<ion-card>

  <div>
    <ion-label *ngIf="statusMultiluck"><b>Parabéns!</b> <br> Você <b>GANHOU</b> um</ion-label>
    <ion-label *ngIf="!statusMultiluck">Não foi desta vez, <b> tente novamente! </b></ion-label>
    <ion-img [src]="!statusMultiluck ? '../../../assets/icon/multiluck/bad.svg' : image"></ion-img>

    <span *ngIf="productName"><strong>{{productName}}</strong></span>
  </div>

  <ion-button (click)="touchDismiss()">{{!statusMultiluck ? 'OK' : 'RESGATAR PRÊMIO'}}</ion-button>
</ion-card>
